import React from 'react';
import { TextInput, NullableBooleanInput, Pagination, RecordContextProvider, TopToolbar, CreateButton, FilterButton, SortButton, useListContext } from 'react-admin';
import { Grid } from '@mui/material';

import List from '../common/views/List';
import CategoryInput from './inputs/CategoryInput';
import StatusInput from './inputs/StatusInput';
import EventCard from './EventCard';
import CountryReferenceInput from './inputs/CountryReferenceInput';


const filters = [
	<TextInput label="Search" source="q" alwaysOn />,
	<StatusInput alwaysOn />,
	<CategoryInput alwaysOn />,
	<CountryReferenceInput label="Country" source="country_id" reference="countries" sort={{ field: 'name', order: 'ASC' }} />,
	// <ReferenceInput label="Region" source="region_id" reference="regions" sort={{ field: 'name', order: 'ASC' }}>
	// 	<AutocompleteInput optionText={optionText} size="small" />
	// </ReferenceInput>,
	<NullableBooleanInput source="published" />
];

const EventPagination = () => <Pagination rowsPerPageOptions={[20, 40, 100]} />;

const EventActions = () => (
	<TopToolbar>
		<SortButton fields={['id', 'title', 'status', 'category', 'start_at', 'end_at']} />
		<FilterButton />
		<CreateButton />
	</TopToolbar>
);

const EventList = () => (
	<List perPage={20} pagination={<EventPagination />} component="div" filters={filters} actions={<EventActions />}>
		<EventGrid />
	</List>
);

const EventGrid = () => {
	const { data, isLoading } = useListContext();

	if (isLoading) {
		return null;
	}

	return (
		<Grid container spacing={2}>
			{data.map(record => (
				<RecordContextProvider key={record.id} value={record}>
					<Grid xs={12} sm={6} md={4} lg={3} xl={2} item>
						<EventCard record={record} />
					</Grid>
				</RecordContextProvider>
			))}
		</Grid>
	);
};

export default EventList;